import { ViewportScroller } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewChecked, AfterViewInit, Component, HostListener, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { CardPaymentAuthenticationPage } from 'src/app/model/page/group/api-docs/card-payment-authentication-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-card-payment-authentication-page',
  templateUrl: './card-payment-authentication-page.component.html',
  styleUrls: ['./card-payment-authentication-page.component.scss']
})
export class CardPaymentAuthenticationPageComponent implements OnInit, AfterViewChecked, AfterViewInit {
  @Input() href: string = '';
  alreadyScrolled = false;

  cardPaymentAuthenticationPage: CardPaymentAuthenticationPage = {} as CardPaymentAuthenticationPage;
  constructor(private scroller: ViewportScroller, private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngAfterViewChecked() {
    this.scrollToHref(this.href);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.alreadyScrolled = true;
    }, 2000);
  }

  scrollToHref(value: string) {
    if (value && value.length > 0 && !this.alreadyScrolled) {
      this.scroller.scrollToAnchor(value);
    }
    // // console.log('alreadyScrolled : ', this.alreadyScrolled);
    // // console.log('scrollToHref : ' + value);
  }

  // @HostListener('document:mousemove', ['$event.target'])
  // windowClick(target: any) {
  //   // // console.log('document click triggered');
  //   this.alreadyScrolled = true;
  // }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'card-payment-authentication') {
        this.cardPaymentAuthenticationPage.htmlTitle = title.htmlTitle;
      }
    });
    this.cardPaymentAuthenticationPage.noteSections = [];
    this.cardPaymentAuthenticationPage.DangerNoteSections = [];
    this.cardPaymentAuthenticationPage.introductionSections = [];
    this.cardPaymentAuthenticationPage.introductionAPIFlowSections = [];
    this.cardPaymentAuthenticationPage.aboveAuthenticationProcessSections = [];
    this.cardPaymentAuthenticationPage.importantToKnowNoteSections = [];
    this.cardPaymentAuthenticationPage.aboveWarningSections = [];
    this.cardPaymentAuthenticationPage.WarningNoteSections = [];
    this.cardPaymentAuthenticationPage.belowWarningSections = [];
    this.cardPaymentAuthenticationPage.authenticationProcessAPIFlowSections = [];
    this.cardPaymentAuthenticationPage.faqSections = [];
    this.cardPaymentAuthenticationPage.sections = [];

    const query = { 'fields.title': 'Card Payment Authentication' };
    this.contentfulService.getPageContentResponse(query).then((cardPaymentAuthenticationPageEntries) => {
      this.mapBanner(cardPaymentAuthenticationPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.cardPaymentAuthenticationPage.banner);
      this.mapSection(cardPaymentAuthenticationPageEntries.includes.Entry);
      this.mapNoteSection(cardPaymentAuthenticationPageEntries.includes.Entry);
      this.mapPageInfo(cardPaymentAuthenticationPageEntries.items);
    });
  }

  private mapBanner(cardPaymentAuthenticationPageEntries: Entry<any>[]) {
    cardPaymentAuthenticationPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.cardPaymentAuthenticationPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapSection(orderRetrievePageSectionEntry: Entry<any>[]) {
    orderRetrievePageSectionEntry
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case 'introduction':
            this.mapEntryToIntroductionSection(entry);
            break;
          case 'introduction-api-flow':
            this.mapEntryToIntroductionAPIFlowSection(entry);
            break;
          case 'above-authentication-process':
            this.mapEntryToAboveAuthenticationProcessSection(entry);
            break;
          case 'above-warning':
            this.mapEntryToAboveWarningSection(entry);
            break;
          case 'below-warning':
            this.mapEntryToBelowWarningSection(entry);
            break;
          case 'authentication-process-api-flow':
            this.mapEntryToAuthenticationProcessAPIFlowSection(entry);
            break;
          case 'faqSections':
            this.mapEntryToFAQSection(entry);
            break;
          default:
            console.error('New group Found - ' + entry.fields['title']);
            break;
        }
      });
  }

  private mapEntryToIntroductionSection(entry: Entry<any>) {
    if (typeof entry.fields['xml'] !== 'undefined') {
      let givenXmlTitle: any = entry.fields['xml'];
      let xmlReponseTitle: any = givenXmlTitle.content[0].data.target.fields.title as string;

      let xmlTitle = xmlReponseTitle.split('#').pop();
      this.httpClient.get(givenXmlTitle.content[0].data.target.fields.file.url, { responseType: 'text' }).subscribe({
        next: (data: string) => this.mapEntryToIntroductionSectionWithXMLData(entry, data, xmlTitle),
        error: () => this.mapEntryToIntroductionSectionWithXMLData(entry, '', '')
      });
    } else {
      this.mapEntryToIntroductionSectionWithXMLData(entry, '', '');
    }
  }

  private mapEntryToIntroductionSectionWithXMLData(entry: Entry<any>, xmlData: string, xmlTitle: string) {
    this.cardPaymentAuthenticationPage.introductionSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry.fields['subBody'] as string,
      heading: entry.fields['heading'] as string,
      xmlTitle: xmlTitle,
      xmlData: xmlData
    });
    this.cardPaymentAuthenticationPage.introductionSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToIntroductionAPIFlowSection(entry: Entry<any>) {
    let tBody: string[] = [];
    let pageBody: any = entry.fields['body'] as string;
    pageBody.split('@').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });
    this.cardPaymentAuthenticationPage.introductionAPIFlowSections.push({
      title: '',
      body: '',
      bodyArrows: tBody,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      subBody: entry.fields['subBody'] as string
    });
    this.cardPaymentAuthenticationPage.introductionAPIFlowSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToAboveAuthenticationProcessSection(entry: Entry<any>) {
    if (typeof entry.fields['xml'] !== 'undefined') {
      let givenXmlTitle: any = entry.fields['xml'];
      let xmlReponseTitle: any = givenXmlTitle.content[0].data.target.fields.title as string;

      let xmlTitle = xmlReponseTitle.split('#').pop();
      this.httpClient.get(givenXmlTitle.content[0].data.target.fields.file.url, { responseType: 'text' }).subscribe({
        next: (data: string) => this.mapEntryToAboveAuthenticationProcessSectionWithXMLData(entry, data, xmlTitle),
        error: () => this.mapEntryToAboveAuthenticationProcessSectionWithXMLData(entry, '', '')
      });
    }
  }
  private mapEntryToAboveAuthenticationProcessSectionWithXMLData(entry: Entry<any>, xmlData: string, xmlTitle: string) {
    this.cardPaymentAuthenticationPage.aboveAuthenticationProcessSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      heading: entry.fields['heading'] as string,
      xmlTitle: xmlTitle,
      xmlData: xmlData
    });
    this.cardPaymentAuthenticationPage.aboveAuthenticationProcessSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToAboveWarningSection(entry: Entry<any>) {
    this.cardPaymentAuthenticationPage.aboveWarningSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
    this.cardPaymentAuthenticationPage.aboveWarningSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToBelowWarningSection(entry: Entry<any>) {
    if (typeof entry.fields['xml'] !== 'undefined') {
      let givenXmlTitle: any = entry.fields['xml'];
      let xmlReponseTitle: any = givenXmlTitle.content[0].data.target.fields.title as string;

      let xmlTitle = xmlReponseTitle.split('#').pop();
      this.httpClient.get(xmlReponseTitle.content[0].data.target.fields.file.url, { responseType: 'text' }).subscribe({
        next: (data: string) => this.mapEntryToBelowWarningSectionWithXMLData(entry, data, xmlTitle),
        error: () => this.mapEntryToBelowWarningSectionWithXMLData(entry, '', '')
      });
    }
  }
  private mapEntryToBelowWarningSectionWithXMLData(entry: Entry<any>, xmlData: string, xmlTitle: string) {
    this.cardPaymentAuthenticationPage.belowWarningSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      xmlTitle: xmlTitle,
      xmlData: xmlData,
      subBody: entry.fields['subBody'] as string
    });
    this.cardPaymentAuthenticationPage.belowWarningSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToAuthenticationProcessAPIFlowSection(entry: Entry<any>) {
    let tBody: string[] = [];

    let pageBody: any = entry.fields['body'] as string;
    pageBody.split('@').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });
    this.cardPaymentAuthenticationPage.authenticationProcessAPIFlowSections.push({
      title: '',
      body: '',
      bodyArrows: tBody,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string
    });
    this.cardPaymentAuthenticationPage.authenticationProcessAPIFlowSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToFAQSection(entry: Entry<any>) {
    if (typeof entry.fields['xml'] !== 'undefined') {
      let givenXmlTitle: any = entry.fields['xml'];
      let xmlReponseTitle: any = givenXmlTitle.content[0].data.target.fields.title as string;
      let xmlTitle = xmlReponseTitle.split('#').pop();
      this.httpClient.get(givenXmlTitle.content[0].data.target.fields.file.url, { responseType: 'text' }).subscribe({
        next: (data: string) => this.mapEntryToFAQSectionWithXMLData(entry, data, xmlTitle),
        error: () => this.mapEntryToFAQSectionWithXMLData(entry, '', '')
      });
    } else {
      this.mapEntryToFAQSectionWithXMLData(entry, '', '');
    }
  }
  private mapEntryToFAQSectionWithXMLData(entry: Entry<any>, xmlData: string, xmlTitle: string) {
    this.cardPaymentAuthenticationPage.faqSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      heading: entry.fields['heading'] as string,
      xmlTitle: xmlTitle,
      xmlData: xmlData
    });
    this.cardPaymentAuthenticationPage.faqSections.sort((a, b) => a.order - b.order);
  }

  private mapNoteSection(entry: Entry<any>[]) {
    entry.filter((entry) => ModelValidator.isNote(entry));
    entry.forEach((entry) => {
      switch (entry.fields['group']) {
        case 'note':
          this.mapEntryToDangerNoteSection(entry);
          break;
        case 'important-to-know':
          this.mapEntryToimportantToKnowNoteSection(entry);
          break;
        case 'warning':
          this.mapEntryToWarningNoteSection(entry);
          break;
      }
    });
  }

  private mapEntryToDangerNoteSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.cardPaymentAuthenticationPage.DangerNoteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      fullTitle: entry.fields['title'] as string,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
  }

  private mapEntryToimportantToKnowNoteSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.cardPaymentAuthenticationPage.importantToKnowNoteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      fullTitle: entry.fields['title'] as string,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
  }

  private mapEntryToWarningNoteSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.cardPaymentAuthenticationPage.WarningNoteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      fullTitle: entry.fields['title'] as string,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.cardPaymentAuthenticationPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.cardPaymentAuthenticationPage.banner.url = entry.fields?.url;
      this.cardPaymentAuthenticationPage.banner.editorEmail = editorDetails?.pop();
      this.cardPaymentAuthenticationPage.banner.editorShortName = editorDetails?.pop();
      this.cardPaymentAuthenticationPage.banner.editorFullName = editorDetails?.pop();
      this.cardPaymentAuthenticationPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
